import React from 'react';
import Section from '../components/ui/Section';
import Mission from '../components/about/Mission';
import Team from '../components/about/Team';
import CallToAction from '../components/home/CallToAction';

const AboutPage: React.FC = () => {
  return (
    <>
      <Section className="pt-32 md:pt-40">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            About <span className="text-primary">Product Leap AI</span>
          </h1>
          <p className="text-xl md:text-2xl text-neutral-300">
            We guide businesses through the complexities of AI product development with strategic expertise and hands-on guidance.
          </p>
        </div>
      </Section>
      
      <Mission />
      <Team />
      <CallToAction />
    </>
  );
};

export default AboutPage;